import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../../UI/Modal/Modal'
import css from './DeleteModal.module.css'
import { AppContext } from '../../../../providers/appProvider';
import Remove from "../../../../assets/Icon/Remove";
import { useTranslation } from 'react-i18next';

const TransportPriceDeleteModal = ({ transportPriceService, defaultTransportPrice }) => {
    const {t} = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { appState, app } = useContext(AppContext);

    const confirmDelete = () => { 
        transportPriceService.remove(defaultTransportPrice.id)
            .then((response) => {
                setIsModalOpen(false) 
            })
            .catch((error) => {
                setIsModalOpen(false)
                app.setError("შეცდომა წაშლისას")
            });
    };

    const openDelete = () => {
        setIsModalOpen(true)
    }

    const closeDelete = () => {
        setIsModalOpen(false)
    }

    return (
        <div>
            <span className={ css.removeBtn } onClick={() => openDelete()} ><Remove/> {t('Delete')}</span> 
           
            <Modal key={defaultTransportPrice.id} size="medium" isOpen={isModalOpen} onClose={() => closeDelete()}>
                <div className={css.modalHead }><h3>{t('Delete')}</h3></div> 
                <div className={ css.message } >{t('ConfirmDelete')}</div>
                <div className={ css.buttons }>
                    <button className={ css.removeBtnYes } onClick={confirmDelete}>{t('YesIdo')}</button> 
                </div> 
            </Modal>


        </div>
    );
};

export default TransportPriceDeleteModal;